<div *ngIf="isLoading">Loading Folder List...</div>

<select *ngIf="!isLoading" [compareWith]="byId" class="form-control" name="folder" [(ngModel)]="model.folder" [required]="required">
  <option *ngFor="let singleFolder of folders" [ngValue]="singleFolder">{{ singleFolder.name }}</option>
</select>
